<template>
  <div class="flex">
    <Select class="select-width flexnone"
            :filterable="true"
            @on-change="cityChange"
            v-model="data.cityCode"

    >
      <Option value="">请选择</Option>
      <Option v-for="item in cityList" :value="item.code" :key="'keyX'+item.code">{{item.name}}</Option>
    </Select>

    <Select class="select-width flexnone" v-model="data.regionCode">
      <Option value="" v-if="!data.cityCode">请先选择城市</Option>
      <Option v-if="regionList.length>0" value="">请选择</Option>
      <Option v-for="item in regionList" :value="item.code" :key="'keyZ'+item.code">{{item.text}}</Option>
    </Select>

    <div class="flexauto" style="position: relative">
      <div><input type="text" v-model="data.address" :id="'suggestId'+id" size="20"
                  :class="['input-long', 'ivu-input']"/></div>
      <div :id="'searchResultPanel'+id" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
    </div>


  </div>
</template>

<script>
  import {projectregion} from "../../api/project";
  import {addCondition} from "../../api/project";

  export default {
    props: {
      id: {
        type: String,
        default: ''
      }

    },
    data() {
      return {
        regionCodeNeedSet:null,
        isSet:false,
        regionList: [],
        cityList: [],
        data: {
          cityCode: null,
          regionCode: null,
          lng: null,
          lat: null,
          address: ''
        },
        ac:null
      }
    },
    created() {
      addCondition().then(res => {
        if (!res.data) {
          return
        }
        this.cityList = res.data.city

      }).catch(error => {
      })

    },
    mounted() {
      this.$nextTick(() => {
        this.map()
      })

    },
    methods: {
      setData(data){
        this.isSet=true
        // this.data= {
        //   cityCode: '120000',
        //   regionCode: '120101',
        //   lng: 113.915747,
        //   lat: 22.57805,
        //   // address: '勤诚达22世纪'
        // }
        this.data.cityCode=data.cityCode
        this.data.address=data.address||''
        this.data.lng=data.lng
        this.data.lat=data.lat
        this.regionCodeNeedSet=data.regionCode
        this.ac.setInputValue(data.address||'')



      },
      resetData(){
        this.data= {
          cityCode: null,
            regionCode: null,
            lng: null,
            lat: null,
            address: ''
        }


      },
      cityChange(value) {
        this.data.regionCode=null

        if (!this.data.cityCode) {
          this.regionList = []
          return
        }
        var params = {
          cityCode: this.data.cityCode
        }
        projectregion(params).then(res => {
          this.regionList = res.data.region

          if(this.isSet){
            this.data.regionCode=this.regionCodeNeedSet
            this.isSet=false

          }
        })

      },
      map() {

        let _this=this

        // 百度地图API功能
        function G(id) {
          return document.getElementById(id);
        }

        // 初始化地图,设置城市和地图级别。

        var ac = new BMap.Autocomplete(    //建立一个自动完成的对象
          {
            "input": "suggestId" + this.id

          });

        ac.addEventListener("onhighlight", (e) => {  //鼠标放在下拉列表上的事件
          var _value = e.fromitem.value;
          if (e.fromitem.index > -1) {
            ac.setInputValue(e.toitem.value.business)

          }
        });


        ac.addEventListener("onconfirm", (e) => {
          _this.data.lng = null
          _this.data.lat = null
          var _value = e.item.value;
          ac.setInputValue(_value.business)
          _this.data.address = _value.business
          let searchValue = _value.province + _value.city + _value.district + _value.business;


          var myGeo = new BMap.Geocoder();
          myGeo.getPoint(searchValue, (value) => {
            if (!value) {
              return
            }
            _this.data.lng = value.lng
            _this.data.lat = value.lat

          })


        });
        _this.ac=ac


      }

    }
  }


</script>

<style scoped>
  .select-width {
    width: 80px;
    margin-right: 10px;
  }


</style>
